import AccmuLine from "./components/AccmuLine.vue";
import SelectAccmuLine from "./components/SelectAccmuLine.vue";
import serverList from "../../components/serverList/serverOptions.vue";
import DataOptions from "../../components/timeList/dataOptions.vue";
export default {
  components: {
    AccmuLine: AccmuLine,
    SelectAccmuLine: SelectAccmuLine,
    serverList: serverList,
    DataOptions: DataOptions
  },
  name: "OverView",
  data: function data() {
    return {
      selType: 1,
      serverList: [],
      sendTimeArrData: [this.$moment().subtract(1, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      activeName: "first",
      serverID: [],
      searchInfo: {
        server_id: []
      }
    };
  },
  methods: {
    ChangeTimebtn: function ChangeTimebtn() {
      var _this = this;
      this.serverID = this.searchInfo.server_id;
      setTimeout(function () {
        _this.$refs.selectAccmuLine.initTime();
      });
    }
  }
};